import { useEffect, useRef, useState } from "react";
import { BsTrash } from "../../../assets/icons/vander";
import { useQuizStore } from "../../hooks";
import { LoadingData, ErrorMessage } from "../../ui";

export const QuizQuestion = ({ question, questionIndex }) => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    answers,
    alertQuestionIds,
    uploadingFiles,
    fileErrors,

    // Methods
    handleAnswerChange,
    uploadFile,
    deleteFile,
  } = useQuizStore();

  // States ------------------------------------------------//
  const fileInputRef = useRef(null);
  const [selectedFileName, setSelectedFileName] = useState("");

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  const handleNumericInput = (questionId, value) => {
    const weightQuestionId = "e7e75d72-d18a-4249-bd0b-8e038fc78e6b";
    const heightQuestionId = "49980f38-bba1-4231-a0d2-56439c1ed466";

    if (questionId === weightQuestionId) {
      // Peso: permite decimales
      const regex = /^\d*\.?\d*$/;
      if (regex.test(value) || value === "") {
        handleAnswerChange(questionId, value);
      }
    } else if (questionId === heightQuestionId) {
      // Altura: solo números enteros
      const regex = /^\d*$/;
      if (regex.test(value) || value === "") {
        handleAnswerChange(questionId, value);
      }
    } else {
      handleAnswerChange(questionId, value);
    }
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    const uploadState = uploadingFiles[question.followUpQuestion?.id];
    if (
      uploadState &&
      !uploadState.isLoading &&
      (uploadState.files?.length > 0 || uploadState.message?.type === "error")
    ) {
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
        setSelectedFileName("");
      }
    }
  }, [uploadingFiles, question.followUpQuestion?.id]);

  return (
    <div className="vstack gap-2">
      {questionIndex > 0 && <hr className="mb-2 mt-0" />}
      <div id={`question-${question.id}`} className="mb-0">
        {questionIndex + 1}. {question.title}
      </div>

      {question.multipleChoice ? (
        question.questionOptions.map((option) => (
          <div
            className="custom-control custom-radio custom-control-inline"
            key={option.id}
          >
            <div className="form-check mb-0">
              <input
                id={option.id}
                className="form-check-input me-2"
                type="radio"
                name={`question-${question.id}`}
                value={option.value}
                checked={
                  answers.find((answer) => answer.questionId === question.id)
                    ?.value === option.value
                }
                onChange={(e) =>
                  handleAnswerChange(question.id, e.target.value)
                }
              />
              <label
                className="form-check-label fw-normal mb-0"
                htmlFor={option.id}
              >
                {option.value}
              </label>
            </div>
          </div>
        ))
      ) : (
        <input
          type="text"
          className={`form-control mb-0 ${
            alertQuestionIds.includes(question.id) ? "is-invalid" : ""
          }`}
          name={`question-${question.id}`}
          value={
            answers.find((answer) => answer.questionId === question.id)
              ?.value || ""
          }
          onChange={(e) => handleNumericInput(question.id, e.target.value)}
        />
      )}

      {question.requiresFollowUp &&
        (answers.find((answer) => answer.questionId === question.id)?.value ===
          "Si" ||
          answers.find((answer) => answer.questionId === question.id)?.value ===
            "Sí") && (
          <>
            <div className="d-block">
              <label className="form-label mb-0">
                {question.followUpQuestion.title}
              </label>
              {question.followUpQuestion.allowsFileUpload ? (
                <textarea
                  className={`form-control mb-0 ${
                    alertQuestionIds.includes(question.followUpQuestion.id)
                      ? "is-invalid"
                      : ""
                  }`}
                  name={`question-${question.followUpQuestion.id}`}
                  rows={4}
                  value={
                    answers.find(
                      (answer) =>
                        answer.questionId === question.followUpQuestion.id
                    )?.value || ""
                  }
                  onChange={(e) =>
                    handleAnswerChange(
                      question.followUpQuestion.id,
                      e.target.value
                    )
                  }
                />
              ) : (
                <input
                  type="text"
                  className={`form-control mb-0 ${
                    alertQuestionIds.includes(question.followUpQuestion.id)
                      ? "is-invalid"
                      : ""
                  }`}
                  name={`question-${question.followUpQuestion.id}`}
                  value={
                    answers.find(
                      (answer) =>
                        answer.questionId === question.followUpQuestion.id
                    )?.value || ""
                  }
                  onChange={(e) =>
                    handleAnswerChange(
                      question.followUpQuestion.id,
                      e.target.value
                    )
                  }
                />
              )}
            </div>

            {question.followUpQuestion.allowsFileUpload && (
              <div className="d-block">
                <label className="form-label small text-muted mb-0">
                  Subir receta médica
                </label>

                <div className="position-relative">
                  <input
                    ref={fileInputRef}
                    type="file"
                    className="position-absolute opacity-0"
                    accept="image/*,.pdf"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        setSelectedFileName(file.name);
                        uploadFile(question.followUpQuestion.id, file);
                      }
                    }}
                    style={{ zIndex: -1 }}
                  />
                  <div
                    className="form-control d-flex align-items-center gap-2 mb-0"
                    style={{ cursor: "pointer" }}
                    onClick={() => fileInputRef.current?.click()}
                  >
                    <span
                      className={`flex-grow-1 text-truncate ${
                        selectedFileName ||
                        uploadingFiles[question.followUpQuestion.id]?.files
                          ?.length > 0
                          ? "text-dark"
                          : "text-muted"
                      }`}
                    >
                      {uploadingFiles[question.followUpQuestion.id]?.files
                        ?.length > 0
                        ? uploadingFiles[question.followUpQuestion.id].files[0]
                            .originalName
                        : selectedFileName || "No has cargado ningún archivo"}
                    </span>
                    <button
                      type="button"
                      className="btn btn-outline-secondary flex-shrink-0"
                      onClick={(e) => {
                        e.stopPropagation();
                        fileInputRef.current?.click();
                      }}
                    >
                      Subir
                    </button>
                  </div>
                </div>
              </div>
            )}

            {question.followUpQuestion.allowsFileUpload && (
              <>
                {uploadingFiles[question.followUpQuestion.id]?.isLoading && (
                  <LoadingData />
                )}

                {uploadingFiles[question.followUpQuestion.id]?.message?.type ===
                  "error" && (
                  <ErrorMessage>
                    {
                      uploadingFiles[question.followUpQuestion.id]?.message
                        ?.text
                    }
                  </ErrorMessage>
                )}

                {(
                  uploadingFiles[question.followUpQuestion.id]?.files || []
                ).map((file, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-center gap-2 p-2 rounded shadow-sm border border-primary"
                  >
                    <span className="flex-grow-1 text-truncate">
                      {file.fileName}
                    </span>
                    <button
                      type="button"
                      className="btn btn-danger flex-shrink-0"
                      onClick={() =>
                        deleteFile(file.url, question.followUpQuestion.id)
                      }
                    >
                      <BsTrash className="icon" />
                    </button>
                  </div>
                ))}

                {fileErrors[question.followUpQuestion.id] && (
                  <small className="text-danger">
                    {fileErrors[question.followUpQuestion.id]}
                  </small>
                )}
              </>
            )}

            {alertQuestionIds.includes(question.followUpQuestion.id) && (
              <p className="text-danger mb-2">
                Debes responder esta pregunta antes de continuar. *
              </p>
            )}
          </>
        )}

      {alertQuestionIds.includes(question.id) && (
        <p className="text-danger mb-2">
          Debes responder esta pregunta antes de continuar. *
        </p>
      )}
    </div>
  );
};
